export const en = {
    continue: 'Continue?',
    'pay-will-not-apply-for-campaigns': 'The selected action is not available for campaigns:'
};
